import { t } from '@lingui/macro';
import { Alert } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function SidebarSectionError() {
    return (<Alert appearance="danger" icon={<Falcon icon="info-circle"/>} message={t({
            message: 'An error occurred trying to get the information.',
            comment: 'Error message displayed when there is a error loading document information sidebar.',
        })}/>);
}
